import { render, staticRenderFns } from "./PaymentMethodItem.vue?vue&type=template&id=6dd3bed8&scoped=true"
import script from "./PaymentMethodItem.vue?vue&type=script&lang=ts"
export * from "./PaymentMethodItem.vue?vue&type=script&lang=ts"
import style0 from "./PaymentMethodItem.vue?vue&type=style&index=0&id=6dd3bed8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd3bed8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dd3bed8')) {
      api.createRecord('6dd3bed8', component.options)
    } else {
      api.reload('6dd3bed8', component.options)
    }
    module.hot.accept("./PaymentMethodItem.vue?vue&type=template&id=6dd3bed8&scoped=true", function () {
      api.rerender('6dd3bed8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/PaymentMethodItem.vue"
export default component.exports